/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { NewDailyRate } from './';
import {
    NewDailyRateFromJSON,
    NewDailyRateFromJSONTyped,
    NewDailyRateToJSON,
} from './';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface NewDailyRateWithOrigin
 */
export interface NewDailyRateWithOrigin {
    /**
     * 
     * @type {Origin}
     * @memberof NewDailyRateWithOrigin
     */
    origin: Origin;
    /**
     * 
     * @type {NewDailyRate}
     * @memberof NewDailyRateWithOrigin
     */
    dailyRate: NewDailyRate;
}

/**
 * Check if a given object implements the NewDailyRateWithOrigin interface.
 */
export function instanceOfNewDailyRateWithOrigin(value: object): value is NewDailyRateWithOrigin {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    return true;
}

export function NewDailyRateWithOriginFromJSON(json: any): NewDailyRateWithOrigin {
    return NewDailyRateWithOriginFromJSONTyped(json, false);
}

export function NewDailyRateWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewDailyRateWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': OriginFromJSON(json['origin']),
        'dailyRate': NewDailyRateFromJSON(json['dailyRate']),
    };
}

export function NewDailyRateWithOriginToJSON(value?: NewDailyRateWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'origin': OriginToJSON(value['origin']),
        'dailyRate': NewDailyRateToJSON(value['dailyRate']),
    };
}

